import { NEGATIVE_WATER_LABEL } from '../../../modules/Logistics/FuelReceptions/pages/TestResult/const'
import { OrderData, NumberType, Order, OrderStatus, Photo, TestResultType } from './types'

interface TestResultActionType {
  type: 'setTestResult'
  payload: TestResultType
}

type Action =
  | {
      type: 'initialData'
      payload: OrderData
    }
  | {
      type: 'setPhoto'
      payload: Photo
    }
  | {
      type: 'setNumber'
      payload: { value: number; type: NumberType }
    }
  | TestResultActionType
  | {
      type: 'setForm'
      payload: Order
    }
  | {
      type: 'statusChange'
      form?: TestResultActionType
      payload: { status: OrderStatus; time: string }
    }

export const formReducer = (formState: Order, action: Action): Order => {
  switch (action.type) {
    case 'initialData':
      return {
        ...formState,
        ...action.payload,
        photos: null,
        testResult: null,
        stateForm: null,
        savedAt: null,
        statusDetail: null,
        numberOfLiters: null,
        voucherNumber: null,
        meterNumber: null,
      }
    case 'setPhoto':
      return {
        ...formState,
        photos: {
          ...formState.photos,
          [action.payload.type]: {
            uri: action.payload.uri,
            dateTime: action.payload.dateTime,
            resourceType: action.payload.resourceType,
            type: action.payload.type,
          },
        },
      }

    case 'setNumber':
      return {
        ...formState,
        [action.payload.type]: action.payload.value,
      }
    case 'setTestResult':
      return {
        ...formState,
        testResult: action.payload,
      }
    case 'setForm':
      return {
        ...action.payload,
      }

    case 'statusChange':
      return {
        ...formState,
        testResult: action.form && action.form.payload ? action.form.payload : NEGATIVE_WATER_LABEL,
        statusDetail: {
          ...formState.statusDetail,
          [action.payload.status]: { ...action.payload },
        },
      }
    default:
      return formState
  }
}
